import AdminGuard from "helpers/AuthType/AdminGuard";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Input,
    Button
} from "reactstrap";

const builderOptions = [
    { value: 1, label: "Builder A" },
    { value: 2, label: "Builder B" },
];

const projectOptions = [
    { value: 101, label: "Project Sunrise" },
    { value: 102, label: "Project Skyline" },
];

const visitorOptions = [
    { value: 201, label: "Aniket Tripathi - 9586363303" },
    { value: 202, label: "Rahul Sharma - 9876543210" },
];

const statusOptions = [
    { value: "Completed", label: "Completed" },
    { value: "Cancelled", label: "Cancelled" },
    { value: "Rescheduled", label: "Rescheduled" },
    { value: "No-show", label: "No-show" },
];

const warmthOptions = [
    { value: "Hot", label: "Hot 🔥" },
    { value: "Warm", label: "Warm 🌤️" },
    { value: "Cold", label: "Cold ❄️" },
];

const WalkingsForm = () => {
    const [formData, setFormData] = useState({
        builder_id: null,
        project_id: null,
        visitor_id: null,
        visit_date: "",
        time_from: "",
        time_to: "",
        walking_status: null,
        warmth_status: null,
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSelect = (name, option) => {
        setFormData({ ...formData, [name]: option });
    };

    const validateForm = () => {
        return (
            formData.builder_id &&
            formData.project_id &&
            formData.visitor_id &&
            formData.visit_date &&
            formData.time_from &&
            formData.time_to &&
            formData.walking_status &&
            formData.warmth_status
        );
    };
    const navigate = useNavigate();

    const AddWalkingDetails = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error("Please fill all mandatory fields");
            return;
        }

        const payload = {
            builder_id: formData.builder_id.value,
            project_id: formData.project_id.value,
            visitor_id: formData.visitor_id.value,
            visit_date: formData.visit_date,
            time_from: formData.time_from,
            time_to: formData.time_to,
            walking_status: formData.walking_status.value,
            warmth_status: formData.warmth_status.value,
        };

        console.log("WALKING PAYLOAD:", payload);

        toast.success("Walking visit saved successfully!");
        // 🔜 API CALL HERE (insertWalking(payload))
    };

    const selectStyle = {
        control: (base) => ({
            ...base,
            background: "rgba(255,255,255,0.15)",
            borderColor: "rgba(255,255,255,0.3)",
            color: "#fff"
        }),
        singleValue: (base) => ({ ...base, color: "#fff" }),
        menu: (base) => ({ ...base, background: "#1E253A", color: "#fff" }),
        option: (base, state) => ({
            ...base,
            background: state.isFocused ? "#6f42c1" : "#1E253A",
            color: "#fff",
            cursor: "pointer"
        })
    };

    return (
        <AdminGuard>
            <React.Fragment>
                <ToastContainer />
                <div className="page-content" style={{ color: "#fff" }}>
                    <Container fluid className="py-2">
                        <Row className="justify-content-center">
                            <Col xl={12}>
                                <Card
                                    style={{
                                        background: "rgba(30,37,58,0.95)",
                                        borderRadius: "16px",
                                        border: "1px solid rgba(255,255,255,0.2)"
                                    }}
                                >
                                    <CardBody>
                                        <div
                                            className="d-flex align-items-center justify-content-between mb-4"
                                        >
                                            <CardTitle className="h3 mb-0">
                                                <i className="bx bx-walk me-2" />
                                                Add Walking Visit
                                            </CardTitle>

                                            <Button
                                                size="sm"
                                                onClick={() => navigate(-1)}
                                                style={{
                                                    background: "rgba(255,255,255,0.1)",
                                                    border: "1px solid rgba(255,255,255,0.3)",
                                                    borderRadius: "10px",
                                                    color: "#fff",
                                                    padding: "6px 14px",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                    transition: "all 0.2s ease"
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = "#6f42c1";
                                                    e.currentTarget.style.boxShadow =
                                                        "0 0 12px rgba(111,66,193,0.7)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background =
                                                        "rgba(255,255,255,0.1)";
                                                    e.currentTarget.style.boxShadow = "none";
                                                }}
                                            >
                                                <i className="bx bx-arrow-back" />
                                                Back
                                            </Button>
                                        </div>


                                        <form>
                                            <Row>
                                                {/* Builder */}
                                                <Col md={4}>
                                                    <Label>Builder *</Label>
                                                    <Select
                                                        options={builderOptions}
                                                        styles={selectStyle}
                                                        onChange={(opt) => handleSelect("builder_id", opt)}
                                                        placeholder="Select Builder"
                                                    />
                                                </Col>

                                                {/* Project */}
                                                <Col md={4}>
                                                    <Label>Project *</Label>
                                                    <Select
                                                        options={projectOptions}
                                                        styles={selectStyle}
                                                        onChange={(opt) => handleSelect("project_id", opt)}
                                                        placeholder="Select Project"
                                                    />
                                                </Col>

                                                {/* Visitor */}
                                                <Col md={4}>
                                                    <Label>Visitor *</Label>
                                                    <Select
                                                        options={visitorOptions}
                                                        styles={selectStyle}
                                                        onChange={(opt) => handleSelect("visitor_id", opt)}
                                                        placeholder="Select Visitor"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                {/* Visit Date */}
                                                <Col md={3}>
                                                    <Label>Visit Date *</Label>
                                                    <Input
                                                        type="date"
                                                        name="visit_date"
                                                        onChange={handleChange}
                                                        style={{
                                                            background: "rgba(255,255,255,0.15)",
                                                            color: "#fff",
                                                            border: "1px solid rgba(255,255,255,0.2)"
                                                        }}
                                                    />
                                                </Col>

                                                {/* Time From */}
                                                <Col md={3}>
                                                    <Label>Time From *</Label>
                                                    <Input
                                                        type="time"
                                                        name="time_from"
                                                        onChange={handleChange}
                                                        style={{
                                                            background: "rgba(255,255,255,0.15)",
                                                            color: "#fff",
                                                            border: "1px solid rgba(255,255,255,0.2)"
                                                        }}
                                                    />
                                                </Col>

                                                {/* Time To */}
                                                <Col md={3}>
                                                    <Label>Time To *</Label>
                                                    <Input
                                                        type="time"
                                                        name="time_to"
                                                        onChange={handleChange}
                                                        style={{
                                                            background: "rgba(255,255,255,0.15)",
                                                            color: "#fff",
                                                            border: "1px solid rgba(255,255,255,0.2)"
                                                        }}
                                                    />
                                                </Col>

                                                {/* Walking Status */}
                                                <Col md={3}>
                                                    <Label>Status *</Label>
                                                    <Select
                                                        options={statusOptions}
                                                        styles={selectStyle}
                                                        onChange={(opt) =>
                                                            handleSelect("walking_status", opt)
                                                        }
                                                        placeholder="Select Status"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                {/* Warmth */}
                                                <Col md={4}>
                                                    <Label>Warmth Status *</Label>
                                                    <Select
                                                        options={warmthOptions}
                                                        styles={selectStyle}
                                                        onChange={(opt) =>
                                                            handleSelect("warmth_status", opt)
                                                        }
                                                        placeholder="Select Warmth"
                                                    />
                                                </Col>
                                            </Row>

                                            <div className="d-flex justify-content-end mt-4">
                                                <Button
                                                    onClick={AddWalkingDetails}
                                                    style={{
                                                        background: "#6f42c1",
                                                        border: "none",
                                                        borderRadius: "12px",
                                                        padding: "10px 30px",
                                                        fontSize: "16px"
                                                    }}
                                                >
                                                    <i className="bx bx-save me-1" />
                                                    Save Visit
                                                </Button>
                                            </div>
                                        </form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        </AdminGuard>
    );
};

export default WalkingsForm;
